var option_webview_default = {
  "option": "ACYXD",
  "user_choice": "IgiXa",
  "check": "UxJGl",
  "image": "xSIRF",
  "input": "QJUGT",
  "title": "Knalp",
  "centered": "cIDWs",
  "with_result": "mqCsb",
  "list": "VcrZl",
  "with_image": "OwjQi",
  "progress": "kstzs",
  "progress_value": "Kx-UL",
  "label": "_5RWpU",
  "cta": "-ZwOj",
  "adornment_icon": "EIFfV",
  "remove": "q39IP",
  "removeButton": "Pb86X",
  "removeButtonIcon": "K-W5x",
  "overlay": "_4gb6t",
  "shown": "qCOlK",
  "dark": "QoH0b",
  "spinner": "SibN-",
  "spin": "_3vCIS",
  "grid": "hYLaE"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
